import { DefaultError, useMutation, useQuery } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { ICreateSettlementOrder, ISettlementOrderResponse } from './types';

export const usePostSettlementOrder = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast('usePostSettlementOrder');
  return useMutation<
    ISettlementOrderResponse,
    DefaultError,
    ICreateSettlementOrder
  >({
    mutationFn: async body => {
      loading(i18next.t('service-message.settlement-order.loading'));

      const response = await apiClient({
        method: 'POST',
        url: 'SettlementOrder',
        body,
      });

      return responseHandler(response, {
        groupName: 'usePostSettlementOrder',
        onNotFound: () => {},
      });
    },
    onSuccess: data => {
      success(i18next.t('service-message.settlement-order.success'));
    },
    onError: dismiss,
  });
};

export const useGetSettlementOrders = () => {
  const { responseHandler } = useResponseHandler();

  return useQuery<ISettlementOrderResponse[], DefaultError>({
    queryKey: ['settlement-orders'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: 'SettlementOrder',
      });

      return responseHandler(response, {
        groupName: 'useGetSettlementOrders',
      });
    },
  });
};
